export default {
  defaultStyle: {
    width: '100%'
  },
  roomAmenities: {
    '@media (min-width: 901px),print': {
      display: 'inline-block',
      color: '#666',
      width: 'calc(65%)',
      marginTop: '15px',
      verticalAlign: 'bottom'
    },
    '& $amenity': {
      '@media (min-width: 901px),print': {
        padding: '3px 3px 3px 26px',
        width: 'calc(47%)',
        display: 'inline-block',
        fontSize: '13px',
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        position: 'relative',
        '&:lang(ar)': {
          paddingRight: "26px",
          paddingLeft: "3px",
          textAlign: "right"
        }
      }
    }
  },
  roomDetailsPad: {
    marginBottom: '10px',
    '@media (min-width: 902px)': {
      marginTop: '5px',
    }
  },
  amenityIcon: {
    position: 'absolute',
    left: '0px',
    top: '50%',
    font: '20px/1px Icons',
    color: '#9b9b9b',
    '&:lang(ar)': {
      left: "auto",
      right: "0"
    }
  },
  servicesList: {
    color: '#666',
    padding: '0 20px 13px',
    boxSizing: 'border-box',
    textAlign: 'left',
    '&:lang(ar)': {
      textAlign: "right"
    },
    '@media (min-width: 801px)': {
      padding: '0 30px 20px'
    },
    '& $amenity': {
      display: 'inline-block',
      verticalAlign: 'middle',
      padding: '4px 5px 2px 26px',
      marginTop: '12px',
      position: 'relative',
      width: 'calc(46%)',
      boxSizing: 'border-box',
      minHeight: '22px',
      textAlign: 'left',
      lineHeight: 'normal',
      marginBottom: '0',
      '&:lang(ar)': {
        paddingRight: "26px",
        paddingLeft: "5px",
        textAlign: "right"
      },
      '&:nth-of-type(1),&:nth-of-type(2)': {
        marginTop: '0'
      },
      '@media (min-width: 801px)': {
        fontSize: '13px',
        lineHeight: '1',
        width: 'calc(100% / 3 - 30px)',
        '&:not(:nth-of-type(3n))': {
          marginRight: '40px',
          '&:lang(ar)': {
            marginRight: "0",
            marginLeft: "40px"
          }
        }
      }
    }
  },
  multiHotelAmenities: {
    borderTop: '1px solid #d8d8d8',
    '& $amenity': {
      marginBottom: '16px',
      '@media (min-width: 901px)': {
        marginBottom: '0'
      }
    }
  },
  amenity: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    '&:lang(ar)': {
      paddingLeft: "5px",
      paddingRight: "26px",
      textAlign: "right"
    },
    display: 'inline-block',
    padding: '2px 5px 2px 26px',
    position: 'relative',
    width: 'calc(50% - 5px)',
    verticalAlign: 'middle',
    boxSizing: 'border-box',
    minHeight: '22px',
    '@media (min-width: 901px),print': {
      '&:not(:first-of-type)&:not(:nth-of-type(2))': {
        marginTop: '12px'
      }
    },
  },
  noWhiteSpace:{
    '& $amenity':{
      whiteSpace:'unset'
    }
  }
};
